import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { adminFetch, setAdminToken } from "../../api/adminApi";
import "./admin.css";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const data = await adminFetch("/v1/auth/login", {
        method: "POST",
        body: JSON.stringify({ email, password }),
      });
      setAdminToken(data.token);
      navigate("/admin/feed", { replace: true });
    } catch (err) {
      setError(err.data?.error || err.message);
    }
  };

  return (
    <div className="pitch-admin-bg flex min-h-screen flex-col items-center justify-center px-4 py-16">
      <div className="mb-10 text-center">
        <Link
          to="/"
          className="font-mono-data text-[10px] font-semibold uppercase tracking-[0.35em] text-slate-500 transition-colors hover:text-[#CCFF00]"
        >
          ← The Pitch Feed site
        </Link>
      </div>

      <div className="pitch-admin-login-card pitch-admin-panel relative w-full max-w-md p-10 md:p-12">
        <div className="relative">
          <div className="mb-2 inline-flex items-center gap-2 rounded-full border border-[#CCFF00]/25 bg-[#CCFF00]/[0.06] px-3 py-1">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#CCFF00] opacity-40" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-[#CCFF00]" />
            </span>
            <span className="font-mono-data text-[9px] font-bold uppercase tracking-[0.2em] text-[#CCFF00]/90">
              Secure area
            </span>
          </div>
          <h1 className="mt-6 text-3xl font-black tracking-tight text-white md:text-4xl">
            Console access
          </h1>
          <p className="mt-3 text-sm leading-relaxed text-slate-400">
            Sign in with an account provisioned by your operator. Public admin
            registration is disabled.
          </p>
          <form onSubmit={submit} className="mt-10 space-y-5">
                        <div>
              <label className="mb-2 block text-[10px] font-black uppercase tracking-[0.22em] text-slate-500">
                Email
              </label>
              <input
                className="pitch-admin-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="username"
                required
              />
            </div>
            <div>
              <label className="mb-2 block text-[10px] font-black uppercase tracking-[0.22em] text-slate-500">
                Password (min 8)
              </label>
              <input
                type="password"
                className="pitch-admin-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
                minLength={8}
              />
            </div>
            {error && (
              <div className="rounded-lg border border-red-500/30 bg-red-500/10 px-4 py-3">
                <p className="font-mono-data break-all text-xs text-red-300">
                  {error}
                </p>
              </div>
            )}
            <button type="submit" className="pitch-admin-btn-primary w-full">
              Enter console
            </button>
          </form>
        </div>
      </div>
      <p className="mt-10 max-w-sm text-center font-mono-data text-[10px] uppercase tracking-[0.2em] text-slate-600">
        Keys never leave this session. Rotate{" "}
        <code className="text-slate-500">ADMIN_JWT_SECRET</code> in production.
      </p>
    </div>
  );
}